import React from 'react';

function CardSkeleton() {
  return (
    <div className="cursor-pointer lg:rounded-lg rounded-[6px] overflow-hidden bg-white border border-[#B8E5FF] h-full animate-pulse">
      {/* Image + Badge */}
      <div className="relative p-[6px] pb-0">
        <span className="absolute right-2.5 top-2.5 px-3 py-1 rounded bg-[#E3EAFF] text-[#002FFF] text-xs font-light">
        &nbsp;
        </span>
        <div className="relative w-full aspect-[37/12] rounded-md bg-gray-200" />
      </div>

      {/* Content */}
      <div className="lg:p-4 p-2 lg:max-h-52 overflow-hidden">
        {/* Badge */}
        <div className="lg:mb-2 mb-[6px]">
          <span className="inline-block h-5 w-20 bg-gray-200 rounded" />
        </div>

        {/* Title */}
        <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
        <div className="h-4 bg-gray-200 rounded w-2/4 mb-[14px]" />

        {/* Tags */}
        <div className="flex lg:mb-[19px] mb-[11px]">
          <div className="h-5 w-16 bg-gray-200 rounded mr-2" />
          <div className="h-5 w-20 bg-gray-200 rounded" />
        </div>

        {/* Footer Info Section */}
        <div className="bg-[#B8E5FF2E] lg:py-[13px] py-[11px] lg:px-4 px-[14px] rounded">
          <ul className="flex justify-between">
            <li className="flex items-center space-x-2">
              <div className="w-5 h-5 bg-gray-300 rounded-full" />
              <div className="h-4 w-24 bg-gray-200 rounded" />
            </li>
            <li className="flex items-center space-x-2">
              <div className="w-5 h-5 bg-gray-300 rounded-full" />
              <div className="h-4 w-24 bg-gray-200 rounded" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default CardSkeleton;
